import { Instagram, MessageCircle } from "lucide-react";

const socials = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/butterhoneylabs?igsh=Zmg2cDU4MnR5NTk3",
    Icon: Instagram,
    handle: "@butterhoneylabs",
  },
  {
    label: "WhatsApp",
    href: "https://wa.me/919606256792",
    Icon: MessageCircle,
    handle: "+91 96062 56792",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-[#2a1f17] bg-[#0a0705]"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-10 px-6 py-16 md:flex-row md:items-end md:justify-between md:px-10">
        <div className="flex items-start gap-5">
          <img
            src="https://customer-assets-jt897jd0.emergentagent.net/job_web-launch-501/artifacts/2wiz6vr6_Icon.webp"
            alt="Butterhoney Labs mark"
            className="-mt-6 h-28 w-28 object-contain drop-shadow-[0_0_28px_rgba(217,144,54,0.35)] md:-mt-10 md:h-36 md:w-36"
          />
          <div>
            <p className="font-serif-editorial text-3xl italic text-[#d99036] md:text-4xl">
              Butter Honey Labs.
            </p>
            <p className="mt-3 max-w-xs font-body text-sm text-[#a89f91]">
              Crafted with Trust. Designed for Legacy.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
          <div>
            <p className="overline mb-3">Contact</p>
            <a
              href="mailto:biz@butterhoneylabs.com"
              className="font-body text-sm text-[#f9f6f0]"
            >
              biz@butterhoneylabs.com
            </a>
          </div>
          <div>
            <p className="overline mb-3">Socials</p>
            <div className="flex flex-col gap-3">
              {socials.map(({ label, href, Icon, handle }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`social-${label.toLowerCase()}`}
                  className="group inline-flex items-center gap-3 font-body text-sm text-[#f9f6f0]"
                >
                  <span className="flex h-9 w-9 items-center justify-center border border-[#2a1f17] transition-colors duration-500 group-hover:border-[#d99036] group-hover:text-[#d99036]">
                    <Icon size={16} strokeWidth={1.6} />
                  </span>
                  <span className="flex flex-col leading-tight">
                    <span className="font-display text-[11px] uppercase tracking-[0.22em] text-[#a89f91]">
                      {label}
                    </span>
                    <span className="transition-colors duration-500 group-hover:text-[#d99036]">
                      {handle}
                    </span>
                  </span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-[#2a1f17]">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-6 md:px-10">
          <p className="font-body text-[11px] uppercase tracking-[0.24em] text-[#a89f91]">
            © {new Date().getFullYear()} Butter Honey Labs
          </p>
        </div>
      </div>
    </footer>
  );
}
